module.exports = __webpack_public_path__ + "static/media/spices_video_featured.7b0c0bcd.jpg";